

















































import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Emit, Prop, Ref } from 'vue-property-decorator'

import { ColorPickerColors } from '../../ColorPicker/logic'
import { SocketNames } from './components'
import ContextMenu from './components/ContextMenu/ContextMenu.vue'
import Minimap from './components/Minimap/Minimap.vue'
import MobileAddNodeMenu from './components/MobileAddNodeMenu/MobileAddNodeMenu.vue'
import FlowNavbar from './components/Navbar/FlowNavbar.vue'
import FlowSidebar from './components/Sidebar/FlowSidebar.vue'
import ConnectionStatisticsModal from './components/Statistics/ConnectionStatisticsModal.vue'
import CustomEditor from './logic/Editor/CustomEditor'
import FlowHistory from './logic/FlowHistory'
import { CustomNode } from './logic/Nodes'

@Component({
  data() {
    return {
      isMobile,
    }
  },
  components: {
    MobileAddNodeMenu,
    ConnectionStatisticsModal,
    FlowSidebar,
    ContextMenu,
    FlowNavbar,
    Minimap,
  }
})
export default class Flow extends Vue {
  @Prop() editor!: CustomEditor | null

  @Ref('flow') container!: HTMLElement

  @Emit('init')
  init(): HTMLElement {
    return this.container
  }

  showMinimap = !isMobile()

  // eslint-disable-next-line sonarjs/cognitive-complexity
  setNodeColor({ node, color }: { color: string, node: CustomNode }) {
    const old = node.color ? node.color.slice() : null
    node.color = color

    node.outputs.forEach((output) => {
      output.connections.forEach((connection) => {
        if (![ SocketNames.Success, SocketNames.Fail, SocketNames.Inactive ].includes(connection.output.name)) {
          const connectionView = this.editor?.view.connections.get(connection)
          const el = connectionView ? connectionView.el : null

          if (el) {
            const path = el.getElementsByTagName('path')[0] as SVGElement

            if (path) {
              const colorCode = ColorPickerColors.find((c) => c.className === color)

              if (colorCode) {
                path.style.stroke = colorCode.color;
                connection.data.color = color
              }
            }
          }
        }

        const node = connection.input.node

        if ((!node.color || node.color === old) && node.mainInput && node.inputs.get(node.mainInput)?.connections.length === 1) {
          this.setNodeColor({ color, node: connection.input.node })
        }
      })
    })
  }

  mounted(): void {
    this.init()

    this.$watch('editor.isReady', (value) => {
      if (value) {
        const screenDiv = document.getElementById('screenshot-wrapper')

        if (screenDiv) {
          screenDiv.setAttribute('data-screenshot-ready', 'true')
        }
      }
    })
  }

  destroyed() {
    FlowHistory.destroy()
  }
}
